module.exports = "/_next/static/images/f2aa95c47aeafb82feceb9491aef7546-savings-waitlist-promise-1a-lg-2x.jpg";